import Contact from './contactModel';

export default class Location {

  id?: number;
  contact_id?: number;
  address: string = '';
  postcode: string = '';
  city: string = '';
  province: string = '';
  country: string = '';
  floor?: number;

  contact?: Contact;

  constructor() {
    this.contact = new Contact();
  }

}